import { styled } from '@abyss/web/tools/styled';

export const PcpBadge = styled('div', {
  margin: '4px 0px',
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 700,
  fontFamily: 'sans-serif',
  letterSpacing: '0px',
});

export const OutOfNetworkLabelCss = styled('div', {
  fontWeight: 400,
  color: '#4b4d4f',
  lineHeight: '18px',
  marginBottom: 8,
  padding: '2px 10px',
  fontSize: '14px',
});
